import { render } from "./WaveB.vue?vue&type=template&id=b1190e58&scoped=true"
import script from "./WaveB.vue?vue&type=script&lang=js"
export * from "./WaveB.vue?vue&type=script&lang=js"

import "./WaveB.vue?vue&type=style&index=0&id=b1190e58&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1190e58"]])

export default __exports__